import { groupBy } from "lodash";
import { Item__Atividades, ItemPropriedades } from "../../../../../../../services/atividades/GET";

export interface TreemapItem {
    label: string;
    value: number;
    color: string;
    detail?: string;
    sementes?: string;
    textColor?: string;
}

export function obterDadosSementes(todas_atividades_ativas: Item__Atividades[], data_propriedades: ItemPropriedades[]): { treemap: TreemapItem[], area_total: number } {

    const atividades_executadas = (todas_atividades_ativas ?? []).filter(i => i.cod_tipo === 2);
    const add_cod_propriedade = (atividades_executadas ?? []).map(i => {
        return {
            andamentos: i.andamentos?.map(j => {
                return {
                    ...j,
                    insumos: j.insumos?.map(k => {
                        return {
                            ...k,
                            cod_propriedade: i.cod_propriedade,
                            area_executada: j.area
                        }
                    })
                }
            })
        }
    })
    //@ts-ignore
    const apenas_insumos_sementes = (add_cod_propriedade ?? []).map(i => i.andamentos)?.flat()?.map(j => j.insumos)?.flat()?.filter(k => k.cod_tipo === 2);

    const propriedades_insumos = [...new Set((apenas_insumos_sementes ?? []).map(i => i.cod_propriedade))];
    const propriedades_listadas = (data_propriedades ?? [])?.filter(i => propriedades_insumos.includes(i.cod));
    const area_total = (propriedades_listadas ?? [])?.reduce((acc, item) => acc + Number(item.area), 0);

    const agrupar_por_insumo = groupBy(apenas_insumos_sementes, 'insumo_nome');

    const cores = ['#8bd06b', '#238b45', '#41ab5d'];

    const dados_treemap = Object.entries(agrupar_por_insumo)?.map(([nome_insumo, dados_sementes]) => {
        let area = dados_sementes?.reduce((acc, item) => acc + Number(item.area_executada), 0);
        let porcentagem = area / area_total * 100;
        return {
            label: nome_insumo,
            value: porcentagem,
            color: '#8bd06b',
            detail: `${area} ha`,
            sementes: `${dados_sementes?.reduce((acc, item) => acc + Number(item.quantidade), 0)}`,
        }
    }).sort((a, b) => b.value - a.value);

    if (dados_treemap.length <= 4) {
        return {
            treemap: dados_treemap.map((item, i) => ({ ...item, color: cores[i % cores.length] })),
            area_total
        }
    }

    const top3 = dados_treemap.slice(0, 3).map((item, i) => ({ ...item, color: cores[i] }));
    const restante = dados_treemap.slice(3);

    const outros: TreemapItem = {
        label: 'Outros',
        value: restante.reduce((acc, item) => acc + item.value, 0),
        color: '#ffd700',
        detail: `${restante.reduce((acc, item) => acc + parseFloat(item.detail!), 0)} ha`,
        sementes: `${restante.reduce((acc, item) => acc + Number(item.sementes), 0)}`,
        textColor: '#2d3436',
    };


    return {
        treemap: [...top3, outros],
        area_total
    };

}


export function obterDadosSementesCompletos(todas_atividades_ativas: Item__Atividades[], data_propriedades: ItemPropriedades[]): { treemap: TreemapItem[], area_total: number } {
    const atividades_executadas = (todas_atividades_ativas ?? []).filter(i => i.cod_tipo === 2);
    const add_cod_propriedade = (atividades_executadas ?? []).map(i => {
        return {
            andamentos: i.andamentos?.map(j => {
                return {
                    ...j,
                    insumos: j.insumos?.map(k => {
                        return {
                            ...k,
                            cod_propriedade: i.cod_propriedade,
                            area_executada: j.area
                        }
                    })
                }
            })
        }
    })
    //@ts-ignore
    const apenas_insumos_sementes = (add_cod_propriedade ?? []).map(i => i.andamentos)?.flat()?.map(j => j.insumos)?.flat()?.filter(k => k.cod_tipo === 2);

    const propriedades_insumos = [...new Set((apenas_insumos_sementes ?? []).map(i => i.cod_propriedade))];
    const propriedades_listadas = (data_propriedades ?? [])?.filter(i => propriedades_insumos.includes(i.cod));
    const area_total = (propriedades_listadas ?? [])?.reduce((acc, item) => acc + Number(item.area), 0);

    const agrupar_por_insumo = groupBy(apenas_insumos_sementes, 'insumo_nome');
    // const cores = ['#8bd06b', '#238b45', '#41ab5d'];
    const cores = ['#315843', '#5da57d', '#67aa6f', '#78af5e', '#8db14b', '#a6b236', '#c1b120', '#dfad06', '#ffa600',];

    const dados_treemap = Object.entries(agrupar_por_insumo)?.map(([nome_insumo, dados_sementes]) => {
        let area = dados_sementes?.reduce((acc, item) => acc + Number(item.area_executada), 0);
        let porcentagem = area / area_total * 100;
        return {
            label: nome_insumo,
            value: porcentagem,
            color: '#8bd06b',
            detail: `${Number(area)?.toFixed(2)} ha`,
            sementes: `${Number(dados_sementes?.reduce((acc, item) => acc + Number(item.quantidade), 0))?.toFixed(2)}`,
        }
    }).sort((a, b) => b.value - a.value);

    return {
        treemap: dados_treemap.map((item, i) => ({ ...item, color: cores[i % cores.length] })),
        area_total
    };
}